import { Component, Emit, Prop, Watch } from 'vue-property-decorator';
import { AbstractWidgetConfig } from "@/components/Dashboard/Widgets/AbstractWidget/AbstractWidget";
import { WidgetConfigIncomeAndOutgoAgriFieldGroup, WidgetData } from "@/components/Dashboard/Widgets/types/Widget";
import moment from 'moment';

interface AgriFieldGroup {
    id: string,
    name: string
}

@Component
export default class WidgetConfigIncomeAndOutgoAgriFieldGroupPart extends AbstractWidgetConfig<WidgetConfigIncomeAndOutgoAgriFieldGroup> {
    config: WidgetConfigIncomeAndOutgoAgriFieldGroup = {
        agriFieldGroup: '',
        startDate: '',
        endDate: null
    }
    groups: AgriFieldGroup[] = []
    private endDateRadio: 'NOW' | 'DATE' = 'NOW'
    @Prop()
    private value!: boolean
    @Prop()
    public widgetData!: WidgetData;

    @Emit('input')
    input(value: boolean): void {
        value
    }

    @Emit('updateConfig')
    updateConfig(): WidgetConfigIncomeAndOutgoAgriFieldGroup {
        return this.config
    }

    created(): void {
        this.initConfig()
        this.getAgriFieldGroupList()
        this.validate()
    }

    @Watch('widgetData')
    whenOpen(): void {
        this.initConfig()
        this.getAgriFieldGroupList()
        this.validate()
    }

    private initConfig() {
        const today = moment()
        const startDate = today.subtract(3, 'month').format('YYYY-MM-DD')
        if (!this.widgetData.config) {
            this.config = {
                agriFieldGroup: '',
                startDate: startDate,
                endDate: null,
            }
        } else {
            this.config = {...this.widgetData.config}
            this.endDateRadio = this.config.endDate === null ? 'NOW' : 'DATE'
        }
    }

    private getAgriFieldGroupList() {
        this.$apiClient.doRequest('get', `/admin/agri_field_groups`).then((ret: AgriFieldGroup[]) => {
            ret.push({id: 'other', name: '所属なし'})
            this.groups = ret
            if(!this.groups.map(g => g.id).includes(this.config.agriFieldGroup)) {
                this.config.agriFieldGroup = ''
                this.input(false)
            }
        })
    }

    changeEndDateRadio(): void {
        const today = moment()
        this.config.endDate = this.endDateRadio === 'NOW' ? null : today.format('YYYY-MM-DD')
        this.validate()
    }

    validate(): void {
        const startDate = moment(this.config.startDate)
        const endDate = this.config.endDate ? moment(this.config.endDate) : moment()
        const valid = this.config !== null &&
            this.config.agriFieldGroup !== '' &&
            endDate.isSameOrAfter(startDate)

        this.input(valid)
        this.updateConfig()
    }
}
